module.exports = __webpack_public_path__ + "static/media/ub2.e35e7975.png";